import { User } from '@era/security-sdk';
import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const UserResolverActions = createActionGroup({
  source: 'User Resolver',
  events: {
    'Suggested Users requested': emptyProps(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const SuggestedUserApiActions = createActionGroup({
  source: 'Suggested User API',
  events: {
    'Suggested Users loaded': props<{ suggestedUsers: User[] }>(),
    'Error loading Suggested Users': props<{ error: ErrorModel }>(),
  },
});
